import { Button, message, Steps, theme } from 'antd';
import { useState, useEffect } from 'react';
import Form1 from './Form1';
import Form2 from './Form2';
import Form3 from './Form3';
import Form4 from './Form4';
import Form5 from './Form5';
import Form6 from './Form6';
import Form7 from './Form7';
import { Center, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';

import { useToast } from '@chakra-ui/react';

const steps = [
  {
    title: 'Basic Detail',
    content: <Form1 />,
  },
  {
    title: 'Education',
    content: <Form2 />,
  },
  {
    title: 'About',
    content: <Form3 />,
  },
  {
    title: 'Job Profile',
    content: <Form4 />,
  },
  {
    title: 'Finish',
    content: <Form5 />,
  },
  {
    title: 'Internship', // New form title
    content: <Form6 />, // New form component
  },
  {
    title: 'Accomplishment', // New form title
    content: <Form7 />, // New form component
  },
];

const SignUpForms = () => {
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const toast = useToast();

  useEffect(() => {
    if (isSubmitted) {
      const timer = setTimeout(() => {
        navigate('/');
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isSubmitted, navigate]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const next = async() => {
    switch (current) {
      case 0:

        await axios
          .get('http://localhost:3000/student/basicdetails', { withCredentials: true })
          .then((res) => {
            console.log("stu data", res.data);
            if (res.data) {
              setCurrent(current + 1);
            } else {
              toast({
                title: 'Validation Error',
                description: 'Please fill all fields before going ahead.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            // Handle API call error
          });
        break;
      case 1:
        await axios
        .get('http://localhost:3000/student/education', { withCredentials: true })
        .then((res) => {
          console.log("stu data", res.data?.highestDegree);
          if (res.data?.highestDegree  ) {

            setCurrent(current + 1);
          } else {
            toast({
              title: 'Validation Error',
              description: 'Please fill all fields before going ahead.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          // Handle API call error
        });
        break;


        case 2:
          await axios
          .get('http://localhost:3000/student/education', { withCredentials: true })
          .then((res) => {
            console.log("12&10 data", res.data?.twelth);
            if (res.data?.twelth  ) {

              setCurrent(current + 1);
            } else {
              toast({
                title: 'Validation Error',
                description: 'Please fill all fields before going ahead.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            // Handle API call error
          });
          break;

      case 3:
        await axios
        .get('http://localhost:3000/student/projects', { withCredentials: true })
        .then((res) => {
          console.log("just res", res);
          if (res) {

            setCurrent(current + 1);
          } else {
            toast({
              title: 'Validation Error',
              description: 'Please fill all fields before going ahead.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          // Handle API call error
        });
        break;




        case 4:
        await axios
        .get('http://localhost:3000/student/work', { withCredentials: true })
        .then((res) => {
          console.log("responsibility", res);
          if (res  ) {

            setCurrent(current + 1);
          } else {
            toast({
              title: 'Validation Error',
              description: 'Please fill all fields before going ahead.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          // Handle API call error
        });
        break;

        case 5:
        await axios
        .get('http://localhost:3000/student/work', { withCredentials: true })
        .then((res) => {
          console.log("internship", res);
          if (res  ) {

            setCurrent(current + 1);
          } else {
            toast({
              title: 'Validation Error',
              description: 'Please fill all fields before going ahead.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          // Handle API call error
        });
        break;

        case 6:
        await axios
        .get('http://localhost:3000/student/accomplishment', { withCredentials: true })
        .then((res) => {
          console.log("internship", res);
          if (res  ) {

            setCurrent(current + 1);
          } else {
            toast({
              title: 'Validation Error',
              description: 'Please fill all fields before going ahead.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          // Handle API call error
        });
        break;

      default:
        break;
    }

  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    width: '80%', // Set the width to 100%
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    margin: '64px auto', // Center content horizontally
    padding: 20,
  };

  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'flex-start', // Align buttons to the right
    marginTop: '60px',
    marginLeft: '150px',

  };

  const buttonStyle = {
    background: 'blue', // Set the background color to blue
    color: 'white', // Set the text color to white
    fontSize: '20px',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',

  };

  const buttonStyle2 = {
    background: '#32CD32', // Set the background color to blue
    color: 'white', // Set the text color to white
    fontSize: '20px',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',

  };

  const style = document.createElement('style');
style.innerHTML = `
  .step-label-hidden {
    display: none;
  }
`;

document.head.appendChild(style);

  return (
    <>
      {/* <Center>
        <Steps
          current={current}
          items={isMobile ? items.slice(current, current + 1) : items}
          style={{ margin: '60px 20px 20px', maxWidth: '800px' }}
        />
      </Center> */}

      <Center>
        <Steps
          current={current}
          items={isMobile ? items.slice(current, current + 1) : items}
          style={{ margin: '60px 20px 20px', maxWidth: '800px' }}
          labelPlacement="vertical"
        >
          {items.map((item, index) => (
            <Steps.Step
              key={item.key}
              title={current === index ? item.title : (index + 1).toString()}
              className={current === index ? '' : 'step-label-hidden'} // Apply the CSS class conditionally
            />
          ))}
        </Steps>
      </Center>

      <div style={contentStyle}>
        {steps[current].content}

        <div style={buttonContainerStyle}>
          {current < steps.length - 1 && (
            <Button onClick={next} size="large" style={buttonStyle}>Next</Button>
          )}
          {current === steps.length - 1 && (
            <Button
            size="large"
              onClick={() => {
                setIsSubmitted(true);
                message.success('Processing complete!');
              }}
              style={buttonStyle2}
            >
              Done
            </Button>
          )}
          {current > 0 && (
            <Button style={{ margin: '0 8px' }} onClick={prev} size="large">
              Previous
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default SignUpForms;
